import { CandidateJobMatchProfileComponent } from "./candidate-job-match-profile.component";
export var CandidateJobMatchProfileModule = angular
    .module('candidateJobMatchProfile', [])
    .component(CandidateJobMatchProfileComponent.selector, CandidateJobMatchProfileComponent.component)
    .name;
//# sourceMappingURL=candidate-job-match-profile.module.js.map